import React from 'react';
import './Testing.css';
import { useNavigate } from 'react-router-dom';

const Testing = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/login'); // update with your actual login route
    };

    return (
     <div className="login-wrapper">
  <div className="login-half left-side">
    <div className="circle-content">Lo</div>
  </div>

  <div className="login-half right-side">
    <div className="circle-content-1">gin</div>
  </div>

  <div className="login-overlay" onClick={handleClick}>
    Login
  </div>
</div>

  );
};
export default Testing;
